<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="GroupCollection"
  />
</template>

<script>
import { DropDownSectionConsts } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';
import GroupFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/GroupFilters';

const {
  multiSelect,
  selectOne,
} = DropDownSectionConsts;

export default {
  name: 'GroupDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
  ],

  data() {
    const dropDownMenuSections = [
      {
        menuLabel: 'membership suggestions: ',
        menuType: selectOne,
        menuItems: [
          {
            filter: GroupFilters.membershipSuggestion(true),
            label: 'suggested updates',
            action: () => {
              const filterName = GroupFilters.membershipSuggestion(false).name;
              this.deleteFilter({ filterName });
              this.handleDropDownAction(GroupFilters.membershipSuggestion(true));
            },
          },
          {
            filter: GroupFilters.membershipSuggestion(false),
            label: 'no updates',
            action: () => {
              const filterName = GroupFilters.membershipSuggestion(true).name;
              this.deleteFilter({ filterName });
              this.handleDropDownAction(GroupFilters.membershipSuggestion(false));
            },
          },
        ],
      },
      {
        menuLabel: 'permissions: ',
        menuType: multiSelect,
        menuItems: [
          {
            filter: GroupFilters.globalAdministratorSudo(true),
            label: 'global administrator/sudo',
            action: () => {
              this.handleDropDownAction(GroupFilters.globalAdministratorSudo(true));
            },
          },
          {
            filter: GroupFilters.globalPasswordlessSudo(true),
            label: 'global passwordless sudo',
            action: () => {
              this.handleDropDownAction(GroupFilters.globalPasswordlessSudo(true));
            },
          },
        ],
      },
    ];

    return {
      dropDownMenuSections,
    };
  },

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters('GroupCollection', [
      'getFilters',
    ]),
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions('GroupCollection', [
      'deleteFilter',
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
